<template>
  <div>
    <b-dropdown no-caret variant="transparent">
      <template #button-content>
        <div class="cursor-pointer">
          <vue-gravatar :email="user?.email" class="mr-2 avatar rounded-circle" width="30" />
          <img src="@/assets/icons/chevron-down-black.svg" width="15" height="15" />
        </div>
      </template>

      <b-dropdown-item :to="{ name: 'MemberProfile' }">
        Profile
      </b-dropdown-item>
      <b-dropdown-item>
        Log Out
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import VueGravatar from "vue-gravatar";

export default {
  name: "ProfileBubble",
  components: { BDropdown, BDropdownItem, VueGravatar },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
};
</script>
